import Overview from "../../Pages/Overview";
import Team from "../../Pages/Team";
import {
  IconBook,
  IconChalkboard,
  IconCreditCard,
  IconHome,
  IconNotebook,
  IconPalette,
  IconReceipt,
  IconSchool,
  IconUserPlus,
  IconUserCircle,
  IconUsers,
} from "@tabler/icons-react";
import { AdminScopeValueProps } from "../types";

interface RouteProps {
  path: string;
  label: string;
  icon: typeof IconHome;
  scopes: AdminScopeValueProps[];
}
export const RouteList: RouteProps[] = [
  {
    path: "/d/overview",
    label: "Overview",
    icon: IconHome,
    scopes: [],
  },
  {
    path: "/d/team",
    label: "Team",
    icon: IconUsers,
    scopes: ["modify_student"],
  },
  {
    path: "/d/plans",
    label: "Plans",
    icon: IconCreditCard,
    scopes: ["modify_plan"],
  },
  {
    path: "/d/courses",
    label: "Courses",
    icon: IconBook,
    scopes: ["modify_course"],
  },
  {
    path: "/d/teachers",
    label: "Teachers",
    icon: IconChalkboard,
    scopes: ["modify_teacher"],
  },

  {
    path: "/d/blogs",
    label: "Blogs",
    icon: IconNotebook,
    scopes: ["modify_blog"],
  },
  {
    path: "/d/page-editor",
    label: "Page Editor",
    icon: IconPalette,
    scopes: [],
  },
  {
    path: "/d/students",
    label: "Students",
    icon: IconSchool,
    scopes: ["modify_student"],
  },
  {
    path: "/d/waitlist",
    label: "Waitlist",
    icon: IconUserPlus,
    scopes: ["modify_student"],
  },
  {
    path: "/d/billing",
    label: "Billing",
    icon: IconReceipt,
    scopes: ["modify_transaction"],
  },
];
